import { CopyOutlined, FileTextFilled } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import React from 'react'

export const RequestNumber = ({ data }) => {
  return (
    <Horizontal style={{ height: '100%' }} verticalCenter>
      <Texto>{data?.number}</Texto>
      {data?.customer_note && (
        <Popover
          title={<Texto>Delivery Request {data.number}</Texto>}
          content={data?.customer_note}
          placement={'topLeft'}
        >
          <GraviButton
            className='ml-2'
            style={{ border: 'none', minWidth: 30, background: 'transparent' }}
            appearance='outline'
            theme2
            icon={<FileTextFilled />}
          />
        </Popover>
      )}
    </Horizontal>
  )
}
